/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_PasteInputs */

const en_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste event or text`)
};

const fr_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller l'evenement ou le texte`)
};

const de_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis oder Text einfügen`)
};

const it_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla evento o testo`)
};

const ru_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте событие или текст.`)
};

const es_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar evento o texto`)
};

const zh_cn2_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件或文本`)
};

const ja_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントまたはテキストを貼り付ける`)
};

const hi_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट या टेक्स्ट पेस्ट करें`)
};

const pt_pt2_shortcut_keys_desc_paste = /** @type {(inputs: Shortcut_Keys_Desc_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o evento ou o texto.`)
};

/**
* | output |
* | --- |
* | "Paste event or text" |
*
* @param {Shortcut_Keys_Desc_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_paste = /** @type {((inputs?: Shortcut_Keys_Desc_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_paste(inputs)
	if (locale === "de") return de_shortcut_keys_desc_paste(inputs)
	if (locale === "it") return it_shortcut_keys_desc_paste(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_paste(inputs)
	if (locale === "es") return es_shortcut_keys_desc_paste(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_paste(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_paste(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_paste(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_paste(inputs)
	return en_shortcut_keys_desc_paste(inputs)
});